import { buttonRecipe } from "components/core/basic/Button";
import SummaryCard from "components/core/blocks/SummaryCard";
import ListPrograms from "components/custom/programs/ListPrograms";
import { useFetch } from "hooks/api";
import { Link } from "react-router-dom";
import { toTitleCase } from "utils/formatText";
import Card from "components/core/basic/Card";
import { useHistory } from "react-router-dom";
import { ENGINES } from "./constants";
import { css, cx } from "../../../styled-system/css";
import { PageContainer } from "../../components/core/basic/PageContainer";

const ProgramList = ({ engine = "pricing", displayAllPrograms = false, biddingLayout = false, embedded = false }) => {
  const history = useHistory();

  const programQueryParams = {
    engine: engine,
  };

  if (displayAllPrograms) {
    delete programQueryParams["engine"];
  }

  const { data: programData, loading: isProgramDataLoading } = useFetch(
    ["programs", engine],
    "/programs",
    programQueryParams,
    {
      select: (data) => {
        return data.data?.results ?? [];
      },
    },
  );

  const title = ENGINES?.[engine]?.title ?? toTitleCase(engine) + " Rules";

  const LayoutWrapper = ({ children }) => {
    if (embedded) return children;
    return (
      <>
        {biddingLayout ?
          <Card>
            <h3 className={css({ fontWeight: "bold", fontSize: "xxlarge" })}>{title} </h3>
            {children}
          </Card>
        : <PageContainer>
            <SummaryCard title={title}>{children}</SummaryCard>
          </PageContainer>
        }
      </>
    );
  };

  return (
    <LayoutWrapper>
      <ListPrograms
        isLoading={isProgramDataLoading}
        programs={programData ?? []}
        onClickProgram={(id) => {
          history.push(
            ["pricing"].includes(engine) ? `/user/programs/edit/${id}` : `/user/advertising/programs/edit/${id}`,
          );
        }}
        engine={engine}
        createButton={
          <Link
            to={engine === "pricing" ? "/user/programs/create" : `/user/advertising/programs/create?engine=${engine}`}
            className={cx(buttonRecipe(), css({ marginRight: "auto" }))}
          >
            Create New Rules
          </Link>
        }
        titleColWidth={engine === "bidding" ? 350 : 250}
      />
    </LayoutWrapper>
  );
};

export default ProgramList;
